import React, { useState, useEffect } from 'react';
import { navigate } from 'raviger';
import { Program, Pagination} from 'components';

const ProgramList = ({programs, paginate = true, fromSearch = false}) => {
  const [scholarships, setScholarships] = useState([]);

  const handleClick = (id, isMember) => {
    navigate(`/programs-search/${id}`, { fromSearch, isMember });
  }

  const handleChangePage = (items) => {
    setScholarships(items);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if(!paginate) setScholarships(programs);
  }, [])

  return (
    <>
    {scholarships &&
      scholarships.map((program, index) => (
        <Program key={index} program={program} onClick={handleClick} fromSearch={fromSearch} />
      ))}

    {programs && paginate && (
      <Pagination
        items={programs}
        onPageChange={handleChangePage}
      />
    )}
  </>
  )
}

export default ProgramList
